module.exports = __webpack_public_path__ + "static/img/active8.e57186a2.png";